import './agenda.scss';

/**
 * version    1.0
 * class      <type> (agenda)
 * classdesc  Component that manage agenda section
 */
export class Agenda {}
